/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type PrimaryNavigationRight_viewer = {
    readonly id: string;
    readonly sisenseUserId: string | null;
    readonly backendId: number | null;
    readonly unseenNotifications: number | null;
    readonly projectOwner: boolean | null;
    readonly company: {
        readonly id: string;
        readonly useTimeApproval: boolean | null;
        readonly useTimeOffApproval: boolean | null;
        readonly unit4Enabled: boolean | null;
        readonly isUsingProjectAllocation: boolean | null;
        readonly tier: TierType | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"NotificationMenu_viewer">;
    readonly " $refType": "PrimaryNavigationRight_viewer";
};
export type PrimaryNavigationRight_viewer$data = PrimaryNavigationRight_viewer;
export type PrimaryNavigationRight_viewer$key = {
    readonly " $data"?: PrimaryNavigationRight_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PrimaryNavigationRight_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrimaryNavigationRight_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sisenseUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unseenNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeOffApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationMenu_viewer"
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '59d027747720bb6d8270d79508b9bf32';
export default node;
